module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "divider"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3375b23a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/navbar-nav-dropdown-divider.vue
// module id = 681
// module chunks = 85